/**
 * カード要素 スクロール連動フェードイン
 *
 * ワークス一覧・リクルート一覧のカードが画面に入ったタイミングで
 * opacity + translateY のふわっとした演出で表示する。
 */
document.addEventListener("DOMContentLoaded", function () {
  if (
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  )
    return;

  window.gsap.registerPlugin(window.ScrollTrigger);

  var fromVars = { opacity: 0, y: 30 };
  var toVars = {
    opacity: 1,
    y: 0,
    duration: 0.85,
    ease: "power2.out",
  };

  // Works カード
  var worksItems = document.querySelectorAll(".c_works_list .c_works_item");
  if (worksItems.length) {
    window.gsap.set(worksItems, fromVars);
    window.ScrollTrigger.batch(worksItems, {
      start: "top 90%",
      once: true,
      onEnter: function (batch) {
        window.gsap.to(batch, Object.assign({}, toVars, { stagger: 0.1 }));
      },
    });
  }

  // Recruit カード
  var recruitItems = document.querySelectorAll(
    ".recruit_list .recruit_item",
  );
  if (recruitItems.length) {
    window.gsap.set(recruitItems, fromVars);
    window.ScrollTrigger.batch(recruitItems, {
      start: "top 90%",
      once: true,
      onEnter: function (batch) {
        window.gsap.to(batch, Object.assign({}, toVars, { stagger: 0.12 }));
      },
    });
  }
});
